import { SURVEY_QUESTION_RESPONSE_OPTIONS } from '../enums/survey-question-response-options.enum';
import { USER_SURVEY_STATUS } from '../enums/user-survey-status.enum';

export interface UserSurveyStatus {
    userId: string;
    surveyId: string;
    lastNotifiedAt?: Date;
    status: USER_SURVEY_STATUS;
    createdAt: Date;
    updatedAt: Date;
    createdBy: string;
    updatedBy: string;
    username: string;
    organizationId: string;
    organizationName: string;
}

export interface UserSurveyStatusDto {
    userId: string;
    username: string;
    organizationId: string;
    organizationName: string;
    surveyId: string;
    lastNotifiedAt?: Date | undefined;
    status: USER_SURVEY_STATUS;
    response?: UserSurveyResponseDto;
}

export interface UserSurveyResponseDto {
    userId: string;
    username: string;
    organizationId: string;
    organizationName: string;
    surveyId: string;

    responses?:
        | {
              question1: SURVEY_QUESTION_RESPONSE_OPTIONS;
              question2?: string | undefined;
              question3?: string | undefined;
              question4?: string | undefined;
          }
        | undefined;

    completedAt?: Date | undefined;
}
